/**
 * Margin Module §11.1 — merge API summary (Balance/Credit/Used/Holding) with
 * live open-position MTM so Equity / Free / Level match the position panel.
 */
export function sumLivePositionPnl(positions = []) {
  let total = 0;
  for (const row of positions || []) {
    const rate = Number(row.currencyRate) || 1;
    const pnl = Number(row.profit ?? row.mtm ?? 0);
    if (!Number.isFinite(pnl)) continue;
    total += pnl * rate;
  }
  return total;
}

export function applyLivePnlToMarginSummary(summary, livePnl) {
  if (!summary) return summary;
  const balance = Number(summary.balance) || 0;
  const credit = Number(summary.credit) || 0;
  const used = Number(summary.usedMargin) || 0;
  const blocked = Number(summary.blockedEquity) || 0;
  const holding = Number(summary.holdingMargin) || 0;
  const pnl = Number.isFinite(livePnl) ? livePnl : Number(summary.pnl) || 0;
  const equity = balance + credit + pnl;
  const freeMargin = equity - used - blocked;
  const marginLevel = used > 0 ? (equity / used) * 100 : null;
  const holdingMarginLevel = holding > 0 ? (equity / holding) * 100 : null;
  const withdrawable = Math.max(0, Math.min(balance, freeMargin));

  return {
    ...summary,
    pnl: round2(pnl),
    equity: round2(equity),
    freeMargin: round4(freeMargin),
    marginLevel: marginLevel == null ? null : round4(marginLevel),
    holdingMarginLevel: holdingMarginLevel == null ? null : round4(holdingMarginLevel),
    withdrawable: round2(withdrawable),
  };
}

function round2(n) {
  return Math.round(Number(n) * 100) / 100;
}

function round4(n) {
  return Math.round(Number(n) * 10000) / 10000;
}
